import { IXhrPerformance } from '../types';
import ICache from './ICache';

/**
 * XHR 性能数据缓存
 */
export default class XHRQueue implements ICache {
  private xhrQueue: IXhrPerformance[] = [];
  private static instance: XHRQueue;

  private constructor() { }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new XHRQueue();
    }

    return this.instance;
  }

  clear() {
    this.xhrQueue = [];
  }

  list() {
    return this.xhrQueue;
  }

  push(item: any) {
    this.xhrQueue.push(item);
  }

  size() {
    return this.xhrQueue.length;
  }
}
